// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--crr-hv-const-styl-main {
    width: 100%;
    height: auto;
    padding-top: 10px;
    padding-left: 130px;
    padding-right: 130px;
    max-width: 1920px;
}

.scl--crr-hv-const-styl-main h6 {
    padding: 0;
    margin: 0
}

.scl--crr-hv-const-bread-sec-on {
    width: 100%;
    height: 21px;
    display: flex;
    gap: 3px;
}

.scl--crr-hv-const-bread-sec-on button {
    border: none;
    background-color: transparent;
    cursor: pointer;
    color: rgba(138, 139, 143, 1);
    font-weight: normal;
    font-size: 12px;
    font-family: var(--font-family-inter);
    display: flex;
    align-items: center;
    position: relative;
    gap: 4px;
    margin-bottom: 3px;
    padding: 5px 1px;
}

/* ✅ hover state — same pattern as hire-create.css */
.scl--crr-hv-const-bread-sec-on button:hover,
.scl--crr-hv-const-bread-sec-on button:hover .scl--crr-hv-const-bread-sec-on button .span-bread {
    color: #00000099 ;
    text-decoration: underline ;
    cursor: pointer ;
}

.scl--crr-hv-const-bread-sec-on button:hover svg path {
    stroke: #000000;
}

.scl--crr-hv-const-bread-sec-on span {
    color: rgba(138, 139, 143, 1);
    font-size: 14px;
    display: flex;
    align-items: center;
}

.scl--crr-hv-const-bread-sec-on h6 {
    color: rgba(138, 139, 143, 1);
    font-weight: normal;
    font-size: 12px;
    font-family: var(--typography-text-body-secondary);
    display: flex;
    align-items: center;
    position: relative;
}

.scl--crr-hv-const-bread-sec-on h6 .span-bread {
    position: absolute;
    left: 20px;
    top: 1px;
    font-family: var(--font-family-inter);
}

.scl--crr-hv-const-bread-sec-on h6 svg {
    position: absolute;
    top: 2px;
    left: 2px;
}

.scl--crr-hv-const-title-sec-tw {
    width: 100%;
    display: flex;
}

.scl--crr-hv-const-title-sec-tw .btn-section-two {
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 1);
    cursor: pointer;
    transition: all 0.1s;
    border: none;
}

.scl--crr-hv-const-title-sec-tw .btn-section-two svg path {
    stroke: rgba(138, 139, 143, 0.5);
}

.scl--crr-hv-const-title-sec-tw .btn-section-two:active svg path,
.scl--crr-hv-const-title-sec-tw .btn-section-two:hover svg path {
    stroke: rgba(0, 0, 0, 0.8);
}

.scl--crr-hv-const-title-sec-tw .btn-section-two:active {
    border: 1px solid rgba(142, 142, 147, 1);
    box-shadow:
        0 0 0 2px white,
        0 0 0 4px #2767d2;
}

.scl--crr-hv-const-jb-title-sec-thd {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 20px;
}

.scl--crr-hv-item-const-main-box {
    width: 100%;
    display: flex;
    gap: 15px;
}

.scl--crr-hv-item-const-main-box .title-job {
    display: flex;
    gap: 10px;
}

.scl--crr-hv-item-const-main-box .title-job:first-child {
    width: 462px;
}

.scl--crr-hv-item-const-main-box .title-job h6 {
    color: var(--typography-text-body-secondary);
    width: 100px;
    font-size: 14px;
    font-weight: normal;
    font-family: var(--font-family-inter);
}

.scl--crr-hv-item-const-main-box .title-job span {
    width: calc(100% - 110px);
    color: var(--typography-text-body-primary);
    font-size: 16px;
    font-family: var(--font-family-inter);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.scl--crr-hv-const-jb-desc-sec-fth {
    width: 100%;
    margin-top: 20px;
}

.scl--crr-hv-jb-des-det-sty {
    width: 100%;
}

.scl--crr-hv-jb-des-det-sty h6 {
    font-family: var(--font-family-inter);
    font-size: 16px;
    color: var(--typography-text-body-primary);
    font-weight: normal;
}

.scl--crr-hv-jb-des-det-sty p {
    font-family: var(--font-family-inter);
    font-size: 16px;
    color: var(--typography-text-body-primary);
    font-weight: normal;
    line-height: 22px;
}

.scl--crr-hv-jb-des-det-sty ul {
    padding-left: 13px;
}

.scl--crr-hv-jb-des-det-sty.wierd-ul ul {
    padding-left: 25px;
}

.scl--crr-hv-jb-des-det-sty.wierd-ul ul li::marker {
    font-size: 13px;
}

.scl--crr-hv-jb-des-det-sty ul li::marker {
    font-size: 8px;
}

.scl--crr-hv-jb-des-det-sty ul li {
    color: var(--typography-text-body-primary);
    font-size: 16px;
    font-family: var(--font-family-inter);
    margin-bottom: 22px;
}

.scl--crr-hv-const-jb-btn-sec-fith {
    width: 100%;
    display: flex;
    justify-content: end;
}

.scl--crr-hv-const-jb-btn-sec-fith .scl-components-button-RoundSqureButton-ghost {
    width: 75px;
    height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/page-controller-mod/page-serv/career/css/hire-view.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,oDAAoD;AACpD;;IAEI,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,kDAAkD;IAClD,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wCAAwC;IACxC,eAAe;IACf,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;IACxC;;yBAEqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,4CAA4C;IAC5C,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,0CAA0C;IAC1C,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,0CAA0C;IAC1C,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0CAA0C;IAC1C,eAAe;IACf,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".scl--crr-hv-const-styl-main {\n    width: 100%;\n    height: auto;\n    padding-top: 10px;\n    padding-left: 130px;\n    padding-right: 130px;\n    max-width: 1920px;\n}\n\n.scl--crr-hv-const-styl-main h6 {\n    padding: 0;\n    margin: 0\n}\n\n.scl--crr-hv-const-bread-sec-on {\n    width: 100%;\n    height: 21px;\n    display: flex;\n    gap: 3px;\n}\n\n.scl--crr-hv-const-bread-sec-on button {\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    color: rgba(138, 139, 143, 1);\n    font-weight: normal;\n    font-size: 12px;\n    font-family: var(--font-family-inter);\n    display: flex;\n    align-items: center;\n    position: relative;\n    gap: 4px;\n    margin-bottom: 3px;\n    padding: 5px 1px;\n}\n\n/* ✅ hover state — same pattern as hire-create.css */\n.scl--crr-hv-const-bread-sec-on button:hover,\n.scl--crr-hv-const-bread-sec-on button:hover .scl--crr-hv-const-bread-sec-on button .span-bread {\n    color: #00000099 ;\n    text-decoration: underline ;\n    cursor: pointer ;\n}\n\n.scl--crr-hv-const-bread-sec-on button:hover svg path {\n    stroke: #000000;\n}\n\n.scl--crr-hv-const-bread-sec-on span {\n    color: rgba(138, 139, 143, 1);\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n}\n\n.scl--crr-hv-const-bread-sec-on h6 {\n    color: rgba(138, 139, 143, 1);\n    font-weight: normal;\n    font-size: 12px;\n    font-family: var(--typography-text-body-secondary);\n    display: flex;\n    align-items: center;\n    position: relative;\n}\n\n.scl--crr-hv-const-bread-sec-on h6 .span-bread {\n    position: absolute;\n    left: 20px;\n    top: 1px;\n    font-family: var(--font-family-inter);\n}\n\n.scl--crr-hv-const-bread-sec-on h6 svg {\n    position: absolute;\n    top: 2px;\n    left: 2px;\n}\n\n.scl--crr-hv-const-title-sec-tw {\n    width: 100%;\n    display: flex;\n}\n\n.scl--crr-hv-const-title-sec-tw .btn-section-two {\n    width: 30px;\n    height: 30px;\n    border-radius: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: rgba(255, 255, 255, 1);\n    cursor: pointer;\n    transition: all 0.1s;\n    border: none;\n}\n\n.scl--crr-hv-const-title-sec-tw .btn-section-two svg path {\n    stroke: rgba(138, 139, 143, 0.5);\n}\n\n.scl--crr-hv-const-title-sec-tw .btn-section-two:active svg path,\n.scl--crr-hv-const-title-sec-tw .btn-section-two:hover svg path {\n    stroke: rgba(0, 0, 0, 0.8);\n}\n\n.scl--crr-hv-const-title-sec-tw .btn-section-two:active {\n    border: 1px solid rgba(142, 142, 147, 1);\n    box-shadow:\n        0 0 0 2px white,\n        0 0 0 4px #2767d2;\n}\n\n.scl--crr-hv-const-jb-title-sec-thd {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n    margin-top: 20px;\n}\n\n.scl--crr-hv-item-const-main-box {\n    width: 100%;\n    display: flex;\n    gap: 15px;\n}\n\n.scl--crr-hv-item-const-main-box .title-job {\n    display: flex;\n    gap: 10px;\n}\n\n.scl--crr-hv-item-const-main-box .title-job:first-child {\n    width: 462px;\n}\n\n.scl--crr-hv-item-const-main-box .title-job h6 {\n    color: var(--typography-text-body-secondary);\n    width: 100px;\n    font-size: 14px;\n    font-weight: normal;\n    font-family: var(--font-family-inter);\n}\n\n.scl--crr-hv-item-const-main-box .title-job span {\n    width: calc(100% - 110px);\n    color: var(--typography-text-body-primary);\n    font-size: 16px;\n    font-family: var(--font-family-inter);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap\n}\n\n.scl--crr-hv-const-jb-desc-sec-fth {\n    width: 100%;\n    margin-top: 20px;\n}\n\n.scl--crr-hv-jb-des-det-sty {\n    width: 100%;\n}\n\n.scl--crr-hv-jb-des-det-sty h6 {\n    font-family: var(--font-family-inter);\n    font-size: 16px;\n    color: var(--typography-text-body-primary);\n    font-weight: normal;\n}\n\n.scl--crr-hv-jb-des-det-sty p {\n    font-family: var(--font-family-inter);\n    font-size: 16px;\n    color: var(--typography-text-body-primary);\n    font-weight: normal;\n    line-height: 22px;\n}\n\n.scl--crr-hv-jb-des-det-sty ul {\n    padding-left: 13px;\n}\n\n.scl--crr-hv-jb-des-det-sty.wierd-ul ul {\n    padding-left: 25px;\n}\n\n.scl--crr-hv-jb-des-det-sty.wierd-ul ul li::marker {\n    font-size: 13px;\n}\n\n.scl--crr-hv-jb-des-det-sty ul li::marker {\n    font-size: 8px;\n}\n\n.scl--crr-hv-jb-des-det-sty ul li {\n    color: var(--typography-text-body-primary);\n    font-size: 16px;\n    font-family: var(--font-family-inter);\n    margin-bottom: 22px;\n}\n\n.scl--crr-hv-const-jb-btn-sec-fith {\n    width: 100%;\n    display: flex;\n    justify-content: end;\n}\n\n.scl--crr-hv-const-jb-btn-sec-fith .scl-components-button-RoundSqureButton-ghost {\n    width: 75px;\n    height: 30px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
